import getExtension from "./getFileExtenstions";

export default function checkVideoFormat(filename) {
  let ext = getExtension(filename);
  let isValidFormat = false;

  switch (ext.toLowerCase()) {
    case "ogg":
    case "webm":
    case "mp4":
    case "mpeg-4":
      isValidFormat = true;
  }
  return isValidFormat;
}
